import styled from 'styled-components';

export const StyledNameCell = styled.div`
  min-width: 0;
  flex: 1;
  padding: 10px 12px;
`;

export const NumberCell = styled.div`
  font-family: var(--font-roboto-mono);
  padding: 10px 12px;
`;

export const YoyCell = styled.div<{ $isPositive: boolean; $isZero: boolean }>`
  font-family: var(--font-roboto-mono);
  padding: 10px 12px;
  color: ${({ $isPositive, $isZero }) =>
    $isZero
      ? 'var(--text-soft)'
      : $isPositive
      ? 'var(--viz-bullish)'
      : 'var(--viz-bearish)'};
`;
